import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarEntregasNoAtoDadosIniciais(api, parametros) {        
    parametros.operacao = 'buscarEntregasNoAtoDadosIniciais';

    let retorno = {}

    await api.santriPOST('/rest/orcamento', parametros, 25, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },

  async enviarDadosEntregasNoAto(api, parametros) { 
    parametros.operacao = 'enviarDadosEntregasNoAto';

    let retorno = {}

    await api.santriPOST('/rest/orcamento', parametros, 15, false)
    .then(response => {
     retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
     retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },

  async buscarEntregasNoAtoVerificarDadosLotes(api, parametros) { 
    parametros.operacao = 'buscarEntregasNoAtoVerificarDadosLotes';

    let retorno = {}

    await api.santriPOST('/rest/orcamento', parametros, 15, false)
    .then(response => {
     retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
     retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },
}


// WEBPACK FOOTER //
// ./src/components/Rest/ROrcamento/ROrcamentoBuscarEntregasNoAto.js